import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { selectChannelAdmins } from '@/store/slices/channel-admins/selectors';
import { BLAdmin } from '@/types/profile.types';
import { EPermissions } from '@/types/permissions.types';

/* crew is simply channel admins with producer role */
const useSelectChannelCrew = (): BLAdmin[] => {
  const activeChannel = useAppSelector(getActiveChannel);
  const allAdmins = useAppSelector(selectChannelAdmins);

  return useMemo(() => {
    if (!allAdmins?.length) return [];
    if (!activeChannel) return [];

    return allAdmins.filter((admin) => {
      return admin?.channels?.[activeChannel]?.includes(EPermissions.Producer);
    });
  }, [activeChannel, allAdmins]);
};

export default useSelectChannelCrew;
